export default __webpack_public_path__ + "static/media/brandstof.18eee822.svg";